import { render, staticRenderFns } from "./webpricing.vue?vue&type=template&id=bba99a10&"
import script from "./webpricing.vue?vue&type=script&lang=js&"
export * from "./webpricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports